import buildCorrectGrammarText from "Common/componentUtils/buildCorrectGrammarText";
export default {
    EDIT_PROJECT: "Редактировать проект",
    DELETE_PROJECT: "Удалить проект",
    CONFIRM_DELETE_PROJECT_TEXT: "Вы уверены, что хотите удалить этот проект?",
    CONFIRM_DELETE_PROJECT_HEADER: "Удалить проект",
    CREATE_DOCUMENT: "Создать документ",
    CREATE_DOCUMENT_DESCRIPTION: "Графы, таблицы, карты или контент",
    IMPORT_DOCUMENT: "Импортировать документ",
    IMPORT_DOCUMENT_DESCRIPTION: "Вы можете загрузить файл в формате PDF",
    DOCUMENTS: "Документы",
    TASKS: "Задачи",
    SUMMARY_REPORTS: "Отчеты",
    MANAGE_ACCESS: "Управление доступом",
    TASK_STATISTICS: "Статистика задач",
    buildCountDocumentsTitle: (count) => `${count} ${buildCorrectGrammarText(count, ["документ", "документа", "документов"])}`
};
